export * from "./baselayers";
export * from "./theme";

export const DATE_FORMAT_LONG = "d MMM y";
export const DATE_TIME_FORMAT_LONG = "d MMM y HH:mm:ss";

// segment bulk edit variation variable
export const VARIATION_VARIABLE = "x";

export const LEZ_COLOR = "#1d5d13";
